import { axiosInstance } from '.'
import { UPLOAD_FILE } from './endpoints'

export const homeServices = {
  postUploadFiles: async (filesData: File) => {
    try {
      const formData = new FormData()
      formData.append('file', filesData)
      return await axiosInstance.post(UPLOAD_FILE, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    } catch (error: any) {
      return error.response
    }
  },
}
